// @ts-nocheck
import { get } from 'lodash-es';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import {
  HttpHandler, HttpInterceptor, HttpRequest, HttpEvent,
} from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { RestApiService } from '../service/rest-api.service';
import { AnalyticsService } from '../service/analytics.service';

import { UIKit } from '../ui-kit';

@Injectable()
export class OriginInterceptor implements HttpInterceptor {
  private isBrowser: boolean;

  constructor(
    @Inject(PLATFORM_ID) platformId,
    private analytics: AnalyticsService,
    private restApi: RestApiService,
    @Inject('config') private config: UIKit.UIKITConfig,
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  /**
   *
   */
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<any>> {
    //
    return next
      .handle(this.addOriginTokens(request));
  }

  /**
   * clone request with origin
   */
  private addOriginTokens(request: HttpRequest<unknown>, token: string = this.restApi.accreditation?.token): HttpRequest<unknown> {
    //
    const headers: { [key: string]: string } = request.headers
      .keys()
      .reduce((obj, key) => ({ ...obj, [key]: request.headers.get(key) }), {});
    //
    if (this.isBrowser) {
      //
      const isRequestToProportunity = /proportunity\.co/.test(request.url);
      // const inNotFromLocalhost = !/localhost\:/.test(location.origin);
      //
      if (isRequestToProportunity && this.config.attachOrigin) {
        const origin = this.analytics.origin;
        for (const key of Object.keys(origin)) {
          const headerKey = key.replace(/\_/g, '-');
          headers[`Proportunity-Origin-${headerKey}`] = origin[key];
        }
      }
    }

    //
    return request.clone({
      setHeaders: headers,
    });
  }
}
